import { ReactNode } from 'react'

interface SectionProps {
    children: ReactNode
    className?: string
    glass?: boolean
    id?: string
}

export default function Section({ children, className = '', glass = false, id }: SectionProps) {
    return (
        <section
            id={id}
            className={`w-full py-20 lg:py-32 px-8 lg:px-20 ${glass ? 'glass-section' : ''} ${className}`}
        >
            <div className="max-w-7xl mx-auto">
                {children}
            </div>
        </section>
    )
}

interface SectionHeaderProps {
    title: string
    subtitle?: string
    centered?: boolean
    className?: string
}

export function SectionHeader({ title, subtitle, centered = true, className = '' }: SectionHeaderProps) {
    return (
        <div className={`${centered ? 'text-center' : ''} mb-12 lg:mb-16 ${className}`}>
            <h2 className="text-3xl lg:text-4xl font-semibold text-primary-color mb-4">
                {title}
            </h2>
            {subtitle && (
                <p className="text-lg lg:text-xl font-normal text-secondary-color max-w-3xl mx-auto">
                    {subtitle}
                </p>
            )}
        </div>
    )
}
